import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const DriveTitle = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
`
export const CardRow = styled(Flex)`
  gap: 15px;
  margin: 15px 0 34px;
`
export const RolenameFlex = styled(Flex)`
  margin: 0 0 15px;
`
export const RoleInfoFlex = styled(Flex)`
  padding: 0 40px 0 0;
`

export const RoleInfoStyledFlex = styled(Flex)`
  gap: 1rem;
`

export const TitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
  margin: 10px 0;
`
export const CountDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_30};
`
export const RoleFlex = styled(Flex)`
  padding-right: 70px;
  border-right: ${props => !props?.border && `1px solid ${COLORS.GREY_T_90}`};
`

export const RoleFlexStyled = styled(Flex)`
  border-right: ${props => !props?.border && `1px solid ${COLORS.GREY_T_90}`};
  flex: 1;
`

export const RoleFlexView = styled(Flex)`
  padding-right: 135px;
  border-right: ${props => !props?.border && `1px solid ${COLORS.GREY_T_90}`};
`

export const InterviewDiv = styled.div`
  padding: 1px 25px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
  margin: 15px 0;
`
export const RoundInfoFlex = styled(Flex)`
  padding: 10px 0;
  border-bottom: ${props =>
    !props?.isboader && `1px solid ${COLORS.GREY_T_90}`};
`
export const RounNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_30};
  flex: 0.4;
  margin: 8px 0;
  text-transform: capitalize;
`

export const ClickView = styled.div`
  cursor: pointer;
`
